// import React, { useState, useEffect } from "react";
// import {
//   CSidebar,
//   CSidebarNav,
//   CNavTitle,
//   CNavItem,
//   CSidebarFooter,
// } from "@coreui/react";
// import { Image, Container } from "react-bootstrap";
// import { BiSolidDashboard } from "react-icons/bi";
// import { PiUserList } from "react-icons/pi";
// import { PiCalendarDotsLight } from "react-icons/pi";
// import { FaRegCalendarPlus } from "react-icons/fa";
// import { GrDocumentText } from "react-icons/gr";
// import logo_white from "../../../assets/images/powered_by.png";
// import { BiLogOut } from "react-icons/bi";
// import "@coreui/coreui/dist/css/coreui.min.css";
// import { useLocation } from "react-router-dom";
// import { getOrganisationData } from "../api/Organisation";
// import { useDispatch } from "react-redux";
// import { MdAddChart } from "react-icons/md";
// import { RiMentalHealthLine } from "react-icons/ri";
// import { FaRegAddressCard } from "react-icons/fa";

// import "./index.css";
// export default function Index() {
//   const dispatch = useDispatch();
//   const location = useLocation();
//   const [role, setRole] = useState("");

//   const getOrganisation = () => {
//     const organisationData = JSON.parse(
//       localStorage.getItem("organisationData")
//     );
//     if (organisationData) {
//       // Use the organisation data
//       setRole(organisationData.role);
//       localStorage.setItem("role", organisationData.role);
//     } else {
//       dispatch(getOrganisationData()).then((res) => {
//         if (res.payload.status === "success") {
//           setRole(res.payload.message.payload.role);
//           localStorage.setItem("role", res.payload.message.payload.role);
//           const organisationData = res.payload.message.payload;
//           // Save organisation data to localStorage for later use across views
//           localStorage.setItem(
//             "organisationData",
//             JSON.stringify(organisationData)
//           );
//         }
//       });
//     }
//   };

//   useEffect(() => {
//     getOrganisation();
//   }, []);

//   return (
//     <Container fluid className={"main-sidebar"}>
//       <CSidebar style={{ borderRadius: "10px" }} className="adminSidebar">
//         <CSidebarNav style={{ display: "flex", overflow: "auto" }}>
//           <CNavItem
//             href="/dashboard"
//             className={
//               location.pathname === "/dashboard"
//                 ? "nav-item-active"
//                 : "nav-item"
//             }
//           >
//             <BiSolidDashboard color={"#FFFFFF"} />{" "}
//             <span style={{ marginLeft: "5px" }} className="menu-name">
//               Dashboard
//             </span>
//           </CNavItem>
//           <CNavTitle className="nav-title">MANAGE USERS</CNavTitle>
//           <CNavItem
//             href="/student-list"
//             className={
//               location.pathname === "/student-list"
//                 ? "nav-item-active"
//                 : "nav-item"
//             }
//           >
//             <PiUserList color={"#FFFFFF"} />{" "}
//             <span style={{ marginLeft: "5px" }} className="menu-name">
//               User List
//             </span>
//           </CNavItem>
//           <CNavItem
//             href="/bulk-student"
//             className={
//               location.pathname === "/bulk-student"
//                 ? "nav-item-active"
//                 : "nav-item"
//             }
//           >
//             <MdAddChart color={"#FFFFFF"} />{" "}
//             <span style={{ marginLeft: "5px" }} className="menu-name">
//               Bulk Update Users
//             </span>
//           </CNavItem>
//           {role === "ADMIN" ? (
//             <CNavItem
//               href="/user-risk"
//               className={
//                 location.pathname === "/user-risk"
//                   ? "nav-item-active"
//                   : "nav-item"
//               }
//             >
//               <RiMentalHealthLine color={"#FFFFFF"} />{" "}
//               <span style={{ marginLeft: "5px" }} className="menu-name">
//                 User Risk Profile
//               </span>
//             </CNavItem>
//           ) : null}

//           <CNavTitle className="nav-title">MANAGE PRACTITIONERS</CNavTitle>

//           <CNavItem
//             href="/counsellor-managment"
//             className={
//               location.pathname === "/counsellor-managment"
//                 ? "nav-item-active"
//                 : "nav-item"
//             }
//           >
//             <PiUserList color={"#FFFFFF"} />{" "}
//             <span style={{ marginLeft: "5px" }} className="menu-name">
//               Practitioner List
//             </span>
//           </CNavItem>
//           <CNavItem
//             href="/add-counsellor"
//             className={
//               location.pathname === "/add-counsellor"
//                 ? "nav-item-active"
//                 : "nav-item"
//             }
//           >
//             <FaRegAddressCard color={"#FFFFFF"} />{" "}
//             <span style={{ marginLeft: "5px" }} className="menu-name">
//               Update Practitioners
//             </span>
//           </CNavItem>
//           {/* <CNavItem
//             href="/counsellor-managment"
//             className={
//               location.pathname === "/deactivate-managment"
//                 ? "nav-item-active"
//                 : "nav-item"
//             }
//           >
//             <TbCopyX color={"#FFFFFF"} />{" "}
//             <span style={{ marginLeft: "5px" }} className="menu-name">
//               Deactivate Practitioners
//             </span>
//           </CNavItem> */}
//           <CNavTitle className="nav-title">
//             MANAGE ORGANISATION EVENTS
//           </CNavTitle>
//           <CNavItem
//             href="/calender"
//             className={
//               location.pathname === "/calender" ? "nav-item-active" : "nav-item"
//             }
//           >
//             <PiCalendarDotsLight color={"#FFFFFF"} />{" "}
//             <span style={{ marginLeft: "5px" }} className="menu-name">
//               My Calendar
//             </span>
//           </CNavItem>

//           <CNavItem
//             href="/schedule-wellness"
//             className={
//               location.pathname === "/schedule-wellness"
//                 ? "nav-item-active"
//                 : "nav-item"
//             }
//           >
//             <FaRegCalendarPlus color={"#FFFFFF"} />{" "}
//             <span style={{ marginLeft: "5px" }} className="menu-name">
//               Schedule Session
//             </span>
//           </CNavItem>

//           <CNavItem
//             href="/run-survey"
//             className={
//               location.pathname === "/run-survey"
//                 ? "nav-item-active"
//                 : "nav-item"
//             }
//           >
//             <GrDocumentText color={"#FFFFFF"} />{" "}
//             <span style={{ marginLeft: "5px" }} className="menu-name">
//               Run a Survey
//             </span>
//           </CNavItem>

//           <CNavItem
//             href={"/logout"}
//             className={
//               location.pathname === "/logout" ? "nav-item-active" : "nav-item"
//             }
//           >
//             <BiLogOut color={"#FFFFFF"} />{" "}
//             <span style={{ marginLeft: "5px" }} className="menu-name">
//               Logout
//             </span>
//           </CNavItem>
//         </CSidebarNav>
//         <CSidebarFooter>
//           <div
//             style={{ width: "100%", justifyContent: "center", display: "flex" }}
//           >
//             <Image
//               src={logo_white}
//               style={{ width: "80%", height: "34px", marginLeft: "5px" }}
//             />
//           </div>
//         </CSidebarFooter>
//       </CSidebar>
//     </Container>
//   );
// }

import React, { useLayoutEffect } from "react";
import {
  LayoutDashboard,
  Users,
  BadgeCheck,
  Stethoscope,
  CalendarCheck,
  Calendar,
  Wallet,
  Store,
  BarChart3,
  Bell,
  Settings,
  MessageSquare,
  LogOut,
  ChevronLeft,
} from "lucide-react";
import { ToastContainer, toast } from "react-toastify";
import IMAGES from "../../../../constant/images";
import { isKycUsersOrgAdmin } from "../../../../utils/orgAccess";

export default function Sidebar({ collapsed, setCollapsed }) {
  // Publish the current sidebar width so the TopBar can start right after it;
  // reset on unmount so pages without a sidebar keep a full-width TopBar
  useLayoutEffect(() => {
    const root = document.documentElement;
    root.style.setProperty("--sidebar-w", collapsed ? "64px" : "272px");
    return () => root.style.setProperty("--sidebar-w", "0px");
  }, [collapsed]);

  // `match` lists the path prefixes that should highlight the item
  const routes = [
    {
      slug: "dashboard",
      title: "Dashboard",
      path: "/dashboard",
      icon: LayoutDashboard,
      match: ["/dashboard"],
    },
    {
      slug: "members",
      title: "Members",
      path: "/members",
      icon: Users,
      match: ["/members", "/member-detail", "/add-member", "/bulk-student", "/user-risk"],
    },
    ...(isKycUsersOrgAdmin()
      ? [
          {
            slug: "kyc_users",
            title: "KYC & Card Status",
            path: "/kyc-users",
            icon: BadgeCheck,
            match: ["/kyc-users"],
          },
        ]
      : []),
    {
      slug: "practitioner",
      title: "Practitioners",
      path: "/practitioner",
      icon: Stethoscope,
      match: [
        "/practitioner",
        "/practitioner-detail",
        "/add-practitioner",
        "/counsellor-managment",
        "/add-counsellor",
      ],
    },
    // {
    //   slug: "reports",
    //   title: "Reports",
    //   path: "/",
    //   icon: FileText,
    // },
    {
      slug: "appointments",
      title: "Appointments",
      path: "/appointments",
      icon: CalendarCheck,
      match: ["/appointments", "/appointment-detail", "/member-summary-report"],
    },
    {
      slug: "events",
      title: "Events",
      path: "/calender",
      icon: Calendar,
      match: ["/calender", "/schedule-wellness", "/schedule-health-camp", "/run-survey"],
    },
    {
      slug: "company_wallet",
      title: "Company Wallet",
      path: "/company_wallet",
      icon: Wallet,
    },
    {
      slug: "store",
      title: "Store",
      path: "/store",
      icon: Store,
    },
    {
      slug: "analytics",
      title: "Analytics",
      path: "/analytics",
      icon: BarChart3,
    },
  ];

  const tools = [
    {
      slug: "notification",
      title: "Notifications",
      path: "/notification",
      icon: Bell,
    },
    {
      slug: "settings",
      title: "Settings & Users",
      path: "/settings",
      icon: Settings,
      match: ["/settings", "/profile"],
    },
    {
      slug: "support",
      title: "Support & Tickets",
      path: "/support",
      icon: MessageSquare,
      match: ["/support"],
    },
  ];

  const isDisabledRoute = (path) => {
    return path === "/company_wallet" || path === "/store" || path === "/analytics" || path === "/notification";
  };

  const handleNavigation = (path) => {
    if (isDisabledRoute(path)) {
      // Do nothing for these routes
      return;
    } else if (path === "/") {
      toast.warning("Sorry, this route is unavailable at the moment.");
    } else if (path === "/logout") {
      localStorage.clear();
      window.location.href = "/";
    } else {
      window.location.href = path;
    }
  };

  // Highlight the item whose path prefixes match the current URL
  const isActive = (item) => {
    if (typeof window === "undefined" || !item.match) return false;
    const pathname = window.location.pathname;
    return item.match.some(
      (prefix) => pathname === prefix || pathname.startsWith(prefix + "/")
    );
  };

  // Note: Bootstrap's `.border` utility is !important, so borders here use
  // `border-[1px] border-solid` to keep Tailwind's colors.
  const renderItem = (item) => {
    const active = isActive(item);
    const disabled = isDisabledRoute(item.path);
    const Icon = item.icon;
    return (
      <button
        key={item.slug}
        type="button"
        onClick={() => handleNavigation(item.path)}
        title={collapsed ? item.title : ""}
        className={`group w-full flex items-center gap-3 py-2.5 mb-1 rounded-xl transition-all duration-200 ${
          collapsed ? "justify-center px-0" : "px-3"
        } ${
          disabled
            ? "bg-transparent text-white/40 cursor-not-allowed border-0"
            : active
            ? "bg-white/10 text-white shadow-lg backdrop-blur-md border-[1px] border-solid border-white/10"
            : "bg-transparent text-white/70 hover:bg-white/5 hover:text-white border-0"
        }`}
      >
        <Icon
          size={20}
          className={`flex-shrink-0 transition-colors ${
            disabled
              ? "text-white/30"
              : active
              ? "text-emerald-300"
              : "text-white/60 group-hover:text-white"
          }`}
        />
        {!collapsed && (
          <span className="font-poppins font-medium tracking-wide text-sm truncate text-left">
            {item.title}
          </span>
        )}
      </button>
    );
  };

  return (
    <div
      className={`flex bg-gradient-to-b from-blue-950 to-emerald-950 text-white shadow-2xl transition-all duration-300 ease-in-out rounded-r-3xl flex-col overflow-hidden h-screen ${collapsed ? "w-[64px]" : "w-[272px]"
        } `}
    >
      {/* Logo + collapse toggle */}
      {!collapsed ? (
        <div className="flex items-center justify-between px-3 h-16 flex-shrink-0">
          <div
            className="flex items-center gap-2 cursor-pointer group min-w-0"
            onClick={() => handleNavigation("/dashboard")}
          >
            <div className="w-9 h-9 rounded-full bg-emerald-900/50 flex items-center justify-center overflow-hidden shrink-0 group-hover:scale-105 transition-transform">
              <img
                src={IMAGES.phyber_logo_white}
                alt="Phyber"
                className="w-5 h-5 object-contain select-none pointer-events-none"
                draggable={false}
              />
            </div>
            <img
              src={IMAGES.footer_logo}
              alt="Phyber"
              className="h-4 w-auto object-contain opacity-95 group-hover:opacity-100 transition-opacity select-none pointer-events-none"
              draggable={false}
            />
          </div>
          <button
            type="button"
            onClick={() => setCollapsed(!collapsed)}
            className="w-8 h-8 p-0 rounded-xl bg-white/10 hover:bg-white/20 text-white/70 hover:text-white transition-all border-[1px] border-solid border-white/10 flex items-center justify-center shadow-sm flex-shrink-0"
            title="Collapse sidebar"
          >
            <ChevronLeft size={18} className="text-white/80 flex-shrink-0" />
          </button>
        </div>
      ) : (
        <div className="flex items-center justify-center h-16 flex-shrink-0">
          <button
            type="button"
            onClick={() => setCollapsed(!collapsed)}
            className="w-9 h-9 p-0 rounded-full bg-emerald-900/50 flex items-center justify-center overflow-hidden border-0 hover:scale-105 transition-transform"
            title="Expand sidebar"
          >
            <img
              src={IMAGES.phyber_logo_white}
              alt="Phyber"
              className="w-5 h-5 object-contain select-none pointer-events-none"
              draggable={false}
            />
          </button>
        </div>
      )}

      {/* Main Navigation */}
      <div className="flex-1 overflow-y-auto custom-scrollbar pt-2 pb-4 px-2">
        {routes.map(renderItem)}
      </div>

      {/* Tools Section */}
      <div className="px-2 pt-3 pb-2 bg-black/10 border-t-[1px] border-solid border-x-0 border-b-0 border-white/10 flex-shrink-0">
        <p
          className={`text-[10px] font-poppins font-semibold uppercase tracking-wider text-white/40 mb-2 ${
            collapsed ? "text-center" : "px-3"
          }`}
        >
          Tools
        </p>
        {tools.map(renderItem)}
      </div>

      {/* Footer: Powered by + Logout */}
      <div className="bg-black/20 border-t-[1px] border-solid border-x-0 border-b-0 border-white/5 flex-shrink-0">
        {!collapsed ? (
          <div className="flex items-center gap-1 px-4 pt-3 pb-1">
            <span className="text-[11px] font-poppins text-white/50 whitespace-nowrap">
              Powered by
            </span>
            <img
              src={IMAGES.footer_logo}
              alt="footer_logo"
              className="h-3 object-contain opacity-80"
            />
          </div>
        ) : null}
        <div className="px-2 pb-2 pt-1">
          <button
            type="button"
            onClick={() => handleNavigation("/logout")}
            title={collapsed ? "Logout" : ""}
            className={`group w-full flex items-center gap-3 py-2.5 rounded-xl border-0 bg-transparent text-white/70 hover:bg-white/5 hover:text-white transition-all ${
              collapsed ? "justify-center px-0" : "px-3"
            }`}
          >
            <LogOut
              size={20}
              className="flex-shrink-0 text-white/60 group-hover:text-red-300 transition-colors"
            />
            {!collapsed && (
              <span className="font-poppins font-medium tracking-wide text-sm">
                Logout
              </span>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
